import { PaymentPlan, legacyPricingKeys } from 'api/clients/PaymentPlanClient'
import { BillingFrequency } from 'components/Paywall/UpgradePlanModal/UpgradePlanModal'

export const pricePerMonth = (paymentPlan: PaymentPlan, billingFrequency: BillingFrequency) => {
  if (billingFrequency === 'year') {
    const { unit_amount: yearly_amount, amount_off: yearly_amount_off } = paymentPlan.price.year

    return (yearly_amount - (yearly_amount_off || 0)) / 12
  }

  const { unit_amount: monthly_amount, amount_off: monthly_amount_off } = paymentPlan.price.month

  return monthly_amount - (monthly_amount_off || 0)
}

export const totalPrice = (paymentPlan: PaymentPlan, billingFrequency: BillingFrequency, members_count: number) => {
  const isLegacyPlan = legacyPricingKeys.includes(paymentPlan.key)

  if (billingFrequency === 'year') {
    const { unit_amount, amount_off } = paymentPlan.price.year

    if (isLegacyPlan) return unit_amount * members_count

    return unit_amount - (amount_off || 0)
  }

  const monthly = pricePerMonth(paymentPlan, billingFrequency)

  if (isLegacyPlan) return monthly * members_count

  return monthly
}

export const formatPrice = (price?: number) => {
  if (price === null || price === undefined) return ''
  const formatted = Number(price).toFixed(2)
  return formatted.replace(/\.00$/, '')
}
